import { useEffect, useState } from 'react';
import { view } from '../lib/supabase.js';
import { thTime, thDateTime } from '../lib/util.js';

const LOG_CATS = { contract: 'สัญญา', money: 'เงิน', pdpa: 'ข้อมูลส่วนบุคคล', admin: 'ผู้ดูแลระบบ', stock: 'คลัง' };
const ROLE_TH = { owner: 'เจ้าของ', mgr: 'ผู้จัดการสาขา', lead: 'หัวหน้างาน', staff: 'พนักงานหน้าร้าน', system: 'ระบบ' };

export default function AuditLog() {
  const [log, setLog] = useState([]);
  const [err, setErr] = useState('');
  const [q, setQ] = useState('');
  const [cat, setCat] = useState('ทั้งหมด');
  const [sensOnly, setSensOnly] = useState(false);

  useEffect(() => {
    view('rp_v_audit_log', x => x.order('occurred_at', { ascending: false }).limit(500))
      .then(setLog).catch(e => setErr(e.message));
  }, []);

  const list = log.filter(l => {
    if (cat !== 'ทั้งหมด' && LOG_CATS[l.category] !== cat) return false;
    if (sensOnly && !l.sensitive) return false;
    const s = q.toLowerCase().trim();
    if (s && !(l.actor_name + ' ' + l.action + ' ' + l.detail).toLowerCase().includes(s)) return false;
    return true;
  });

  const today = new Date().toDateString();
  const actorsToday = new Set(log.filter(l => new Date(l.occurred_at).toDateString() === today).map(l => l.actor_name)).size;

  return (<>
    <div className="pagehead">
      <div className="eyebrow">ประวัติการใช้งาน · AUDIT LOG</div>
      <h1 className="bighead">ใครทำอะไร เมื่อไหร่</h1>
      <p className="lede">บันทึกทุกการกระทำที่มีผลต่อเงิน ทรัพย์สิน และข้อมูลส่วนบุคคล · แก้ไขหรือลบรายการย้อนหลังไม่ได้ (บังคับที่ฐานข้อมูล)</p>
    </div>
    {err && <div className="note show" style={{ marginBottom: 16 }}>{err}</div>}
    <div className="statbox" style={{ marginBottom: 20 }}>
      <div className="stat"><div className="k">รายการทั้งหมด · ENTRIES</div><div className="v">{log.length}</div></div>
      <div className="stat ok"><div className="k">รายการอ่อนไหว · SENSITIVE</div><div className="v">{log.filter(l => l.sensitive).length}</div></div>
      <div className="stat"><div className="k">เปิดดูเอกสารบัตร · ID ACCESS</div><div className="v">{log.filter(l => l.category === 'pdpa').length}</div></div>
      <div className="stat"><div className="k">ผู้ใช้งานวันนี้ · ACTORS</div><div className="v">{actorsToday}</div></div>
    </div>
    <div className="pickbar">
      <input className="picksearch" placeholder="ค้นหา ชื่อพนักงาน เลขสัญญา หรือรายละเอียด…" value={q} onChange={e => setQ(e.target.value)} />
      <label className="chk"><input type="checkbox" checked={sensOnly} onChange={e => setSensOnly(e.target.checked)} /> เฉพาะรายการอ่อนไหว</label>
    </div>
    <div className="catfilter">
      {['ทั้งหมด', ...Object.values(LOG_CATS)].map(c => (
        <button key={c} className={c === cat ? 'on' : ''} onClick={() => setCat(c)}>
          {c}{c === 'ทั้งหมด' ? '' : ' · ' + log.filter(l => LOG_CATS[l.category] === c).length}
        </button>
      ))}
    </div>
    <div className="card" style={{ marginTop: 14 }}>
      <table>
        <thead><tr>
          <th style={{ width: 96 }}>เวลา</th><th style={{ width: 150 }}>ผู้ใช้งาน</th><th style={{ width: 120 }}>ประเภท</th><th>รายละเอียด</th>
        </tr></thead>
        <tbody>
          {list.map(l => (
            <tr key={l.id}>
              <td className="mono" style={{ fontSize: 11.5 }}>{thTime(l.occurred_at)}<br />
                <span style={{ color: 'var(--muted)' }}>{thDateTime(l.occurred_at)}</span></td>
              <td><div style={{ fontWeight: 600 }}>{l.actor_name}</div>
                <div style={{ fontSize: 11, color: 'var(--muted)' }}>{ROLE_TH[l.actor_role] || l.actor_role}</div></td>
              <td><span className={'chip ' + (l.sensitive ? 'c-due' : 'c-free')}>{LOG_CATS[l.category]}</span></td>
              <td><div style={{ fontWeight: 600 }}>{l.sensitive ? <span style={{ color: 'var(--gold)' }}>! </span> : ''}{l.action}</div>
                <div style={{ fontSize: 12, color: 'var(--muted)' }}>{l.detail}</div></td>
            </tr>
          ))}
          {!list.length && <tr><td colSpan={4} className="empty">ไม่พบรายการ</td></tr>}
        </tbody>
      </table>
    </div>
  </>);
}
